import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface ISignUpExternalFormData {
  cnpj: string
  name: string
  email: string
  password: string
}

const SignUpExternalSchema: JSONSchemaType<ISignUpExternalFormData> = {
  type: 'object',
  properties: {
    cnpj: {
      type: 'string',
      minLength: 1,
      pattern: validationPatters.cnpj,
      errorMessage: 'CNPJ Inválido.',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Nome é Inválido.',
    },
    email: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'Email é Inválido.',
    },
    password: {
      type: 'string',
      minLength: 8,
      pattern: validationPatters.password,
      errorMessage: 'Senha Inválida.',
    },
  },
  required: ['name', 'cnpj', 'email', 'password'],
  additionalProperties: false,
}

export default SignUpExternalSchema
